import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { StateType } from 'moduleBaseMenu/types/StateType';
import { FC, useMemo } from 'react';

type MenuPanelProps = Pick<StateType, 'menu'> & {
  hide: () => void
};

const MenuPanelBottom: FC<MenuPanelProps> = ({ menu, hide }) => {
  const defaultBottomData = useMemo(() => {
    const activeBlock = menu.blocks.find((block) => block.id === menu.activeBlock);
    return activeBlock.bottom;
  }, []);

  if (!defaultBottomData) {
    return null;
  }

  const bottomMenuItems = defaultBottomData.items.map((menuItem) => (
    <li className="menu-panel-section bg-light" key={menuItem.label}>
      <MenuItem
        {...menuItem}
        className="menu-panel-link container container-lg-fluid"
        onClick={() => {
          hide();
        }}
      />
    </li>
  ));

  return (
    <ul className="list-unstyled mb-0">
      {bottomMenuItems}
    </ul>
  );
};

export { MenuPanelBottom };
